export const useDownload = (file: string[][], fileName: string) => {
  const blob = new Blob(['\ufeff', file.map((row) => row.join(',')).join('\n')], { type: 'text/csv;charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
